import { current_route } from "./router"

export default () => current_route.value
